'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var takeAName = function takeAName(name) {
  var withDisplayName = function withDisplayName(TargetOrName) {
    if (typeof TargetOrName === 'string') {
      return takeAName(name + '.' + TargetOrName);
    } else {
      var WithDisplayName = function WithDisplayName(props) {
        return _react2.default.createElement(TargetOrName, props);
      };

      WithDisplayName.displayName = name;

      return WithDisplayName;
    }
  };

  return withDisplayName;
};

exports.default = takeAName;